import React from 'react';
import { benefits } from '../data/salesCopy';
export function BenefitsSection() {
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-20" data-mp="cqnqr5zq19e">
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="ebgqccnpc55">
        <div className="text-center" data-id="element-22" data-mp="3iqq1vbf3hwpi">
          <h2 className="font-serif text-2xl font-bold uppercase leading-[1.1] text-brand-brown sm:text-4xl" data-id="element-23" data-mp="3ipoq14q9966q">
            Ce n’est pas simplement un autre ebook sur le Yin Yoga
          </h2>
          <p className="mt-2 font-serif text-lg font-bold uppercase tracking-wide text-brand-sage sm:text-2xl" data-id="element-24" data-mp="38qh4hu9da58j">
            C’est un système visuel complet pour vos cours.
          </p>
          <span className="mx-auto mt-2 block h-0.5 w-14 bg-brand-gold" data-id="element-25" data-mp="2zsdrjmcg6gsc" />
        </div>

        <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="34pnix7jed2it">
          {benefits.map(b => <li key={b.title} className="flex h-full flex-col rounded-lg bg-brand-ivory p-3" data-id="element-27" data-mp="y1ahozadt68u">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-28" data-mp="12wpstjh08o1k">
                {b.icon}
              </span>
              <h3 className="mt-1.5 font-sans text-[13px] font-bold uppercase leading-tight tracking-wide text-brand-brown" data-id="element-29" data-mp="27du3cextcoqx">
                {b.title}
              </h3>
              <p className="mt-1 text-[12.5px] font-medium leading-snug text-brand-brown/80" data-id="element-30" data-mp="2l738u4in4q46">
                {b.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}